import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export class GetProceduresWithPaginationService {
  async run(params: parmsRomms) {
    const response :any= await getByQuery<any[]>(`${services.procedures}/list-with-pagination`, params);
    return  {data:response.data, ...response.pagination};
  };
};